import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { subscribePushNavigation } from '../../utils/pushNavigation';

// Sign-in pages redirect on their own; a tap waits until they've finished.
const AUTH_ROUTES = ['/callback', '/login', '/accept-invite'];

/** Opens the chat a tapped notification points to (taps are buffered at bootstrap by utils/pushNavigation). */
const PushNavigationListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onAuthRoute = AUTH_ROUTES.includes(location.pathname);
  const currentUrlRef = useRef('');
  currentUrlRef.current = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (onAuthRoute) return undefined;
    return subscribePushNavigation((url) => {
      if (url !== currentUrlRef.current) navigate(url);
    });
  }, [navigate, onAuthRoute]);

  return null;
};

export default PushNavigationListener;
